import { useBetween } from '../../../shared/use-between/use-between';
import { ShoppingCartUseBetween } from '../../../components/order/use-between/shopping-cart-use-between';
import { UserDetailsUseBetween } from '../../../shared/use-between/user-details-use-between';
import { changeBuildingSite } from '../../../components/shopping-cart/services/shopping-cart.service';
import { updateUserRecentSelection } from '../../../shared/services';
import { IBuildingSiteListViewDto } from '../../../components/order/interfaces/building-site-list-view.interface';
import { IShopingCart } from '../../../components/order/interfaces/shopping-cart.interface';
import { Utils } from '../../../shared/constants/utilities.constants';

// Saves the given building site on the cart order (clearing the now-stale delivery address/contact in the
// same call - see changeBuildingSite's own comment) and remembers it as the user's most recent selection,
// which is what CartOrderForm actually watches to display the currently selected building site.
export const useSelectBuildingSite = () => {
    const { setBuildingSite, setBuildingSiteAddress, setBuyerContact, setIsReadyToOrder, setShoppingCart } =
        useBetween(ShoppingCartUseBetween);
    const { userSelection, setUserSelection } = useBetween(UserDetailsUseBetween);

    const applyCartResponse = (shopingCart: IShopingCart) => {
        setBuildingSite(shopingCart.buildingSite);
        setBuildingSiteAddress(shopingCart.buildingSiteAddress);
        setBuyerContact(shopingCart.buyerContact);
        setIsReadyToOrder(shopingCart.isReadyToOrder);
        setShoppingCart(Utils.clone(shopingCart));
    };

    return (buildingSite: IBuildingSiteListViewDto) => {
        changeBuildingSite(buildingSite).then((response) => {
            if (response) {
                applyCartResponse(response.data);
            }
        });

        if (userSelection) {
            const updatedSelection = { ...userSelection, buildingSiteUuid: buildingSite.id };
            updateUserRecentSelection(updatedSelection).then((userSelectionResponse) => {
                if (userSelectionResponse) {
                    setUserSelection(Utils.clone(updatedSelection));
                }
            });
        }
    };
};
